export const EventType = {
  ORIGINAL: 'ORIGINAL',
  RETAKE: 'RETAKE'
} as const;

export type MasterEventDTO = {
  apoKey: string;
  eventType?: EventType;
  accountName: string;
  subjectInfo: {
    firstName: string;
    lastName: string;
    grade: string;
    portraitIdAccessCode: string | null;
    previewImageUrl: string | null;
    bearerTokenURL?: string | null;
    isGroupOnlyCaptureSession: boolean | null;
  };
  type: keyof typeof EventType;
  schoolYearDisplay: string;
  gradYear?: number;
};

export type EventType = {
  accountName?: string;
  account: {
    accountName: string;
    state: string;
  };
  sellingMethodName: string;
  jobNumber: string;
  subProgramName: string;
  eventDate: string;
  lastPictureDay: string;
};

export type UnverifiedEvent = {
  jobName: string;
  jobNumber: string;
  eventDate: string;
  lastPictureDayDate: string;
  schoolYearDisplay: string;
  sellingMethod: string;
  accountName?: string;
  account?: { accountName?: string };
  gradYear?: number;
};

export type CurrentEvent = {
  accessCode: string;
  event: UnverifiedEvent;
  portraitId: string;
};

export type Subject = {
  id: string;
  ltMasterSubjectUuid: string;
  subjectFirstName: string;
  subjectLastName: string;
  previewImageUrl: string | null;
  bearerTokenURL?: string | null;
  subjectInfo?: MasterEventDTO['subjectInfo'] | null;
  currentGrade: string;
  subjectGrade?: string;
  subjectRelationship?: string;
  selectedEvent?: MasterEventDTO & UnverifiedEvent;
  eventLoading: {
    status: 'pending' | 'error' | 'resolved';
    _promise?: Promise<void>;
  };
  masterEvents?: MasterEventDTO[];
  currentEvent?: CurrentEvent;
  subjectOrderId: string;
  subjectTeacherName?: string;
  dontKnowTeacherName?: string;
  masterSubjectId?: string;
  studentId: string;
  lifetouchId: string;
};
